import { isAfter, isFuture } from 'date-fns'
import i18n from 'i18next'
import { z } from 'zod'

import type { FieldErrorsMapper } from '@/hooks/useMutationWithErrorsHandling'

export const schoolYearPayload = z
  .object({
    firstSemester: z
      .object({
        from: z.date().optional(),
        to: z.date().optional()
      })
      .refine(data => data.from && data.to, {
        message: i18n.t('error.first-semester-dates-required', {
          ns: 'schoolSettings'
        })
      })
      .refine(data => data.from && isFuture(data.from), {
        message: i18n.t('error.date-must-be-in-future', {
          ns: 'common'
        })
      }),
    secondSemester: z
      .object({
        from: z.date().optional(),
        to: z.date().optional()
      })
      .refine(data => data.from && data.to, {
        message: i18n.t('error.second-semester-dates-required', {
          ns: 'schoolSettings'
        })
      })
      .refine(data => data.from && isFuture(data.from), {
        message: i18n.t('error.date-must-be-in-future', {
          ns: 'common'
        })
      })
  })
  .superRefine((data, ctx) => {
    if (
      data.firstSemester.from &&
      data.firstSemester.to &&
      data.secondSemester.from &&
      data.secondSemester.to &&
      !isAfter(data.secondSemester.from, data.firstSemester.to)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('error.semesters-overlap', {
          ns: 'schoolSettings'
        }),
        path: ['secondSemester']
      })
    }
  })

export type SchoolYearFormPayload = z.infer<typeof schoolYearPayload>

export type SchoolYearEditFormPayload = SchoolYearFormPayload & { id: string }

export const schoolYearFieldErrorsMapper: FieldErrorsMapper<SchoolYearFormPayload> =
  {
    first_semester: 'firstSemester',
    second_semester: 'secondSemester',
    'first_semester.start_date': 'firstSemester',
    'second_semester.start_date': 'secondSemester',
    non_field_errors: 'root'
  }
